import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Market } from 'src/interfaces/market'
import { getMarkets, getIsMarketsInitialized } from 'src/selectors/market'

export const useFormatMarketsData = () => {
  const marketsList = useSelector(getMarkets)
  const isMarketsInitialized = useSelector(getIsMarketsInitialized)

  const getParsedMarketsTitles = useCallback(
    (markets: (Market | string)[] | null) => {
      if (!markets?.length) {
        return []
      }

      if (!isMarketsInitialized || !marketsList.length) {
        return []
      }

      const marketTitles = markets.map((market) => {
        if (typeof market === 'string') {
          const found = marketsList.find((item) => item.id === market)

          return found ? found.title : market
        }

        return market.title
      })

      return marketTitles
    },
    [marketsList, isMarketsInitialized],
  )

  return getParsedMarketsTitles
}
